import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { ToggleField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import { useBlockContext } from '../../../contexts/internal/BlockContext.js';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import { DurationInputField } from '../../../components/Duration/DurationInputField.js';
import '../../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import { ColorPickerField } from '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import { convertDurationFormat } from '../../../utils/duration.js';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';
import '../../../components/FieldItem.js';
import { BoxModelForm } from './BoxModelForm/BoxModelForm.js';

var _excluded = ["children"];
function BlockInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var convertedDuration = convertDurationFormat(value.props.duration);
  var formValue = _objectSpread2(_objectSpread2({}, value), {}, {
    props: _objectSpread2(_objectSpread2({}, value.props), {}, {
      duration: convertedDuration
    })
  });
  return jsx(InspectorFormProvider, {
    value: formValue,
    onChange: onChange
  }, jsx(BlockInspectorFields, {
    value: formValue
  }));
}
function BlockInspectorFields(_ref2) {
  var value = _ref2.value;
  var _useBlockContext = useBlockContext(),
    setImpressionLogData = _useBlockContext.setImpressionLogData;
  var _ref3 = value !== null && value !== void 0 ? value : {};
    _ref3.children;
    var others = _objectWithoutProperties(_ref3, _excluded);
  return jsx(React__default.Fragment, null, jsx(BoxModelForm, null), jsx(FormContent, {
    header: "\uBC30\uACBD\uC0C9"
  }, jsx(ColorPickerField, {
    name: "background",
    width: "100%"
  })), jsx(FormContent, {
    header: "\uB178\uCD9C\uC2DC\uAC04 \uC124\uC815"
  }, jsx(ToggleField, {
    name: "duration"
  })), !!value.props.duration && jsx(FormContent, {
    header: "\uB178\uCD9C\uC2DC\uAC04",
    direction: "VERTICAL"
  }, jsx(DurationInputField, {
    name: "duration"
  })), jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key,
    label: "Impression \uB85C\uADF8"
  }, setImpressionLogData === null || setImpressionLogData === void 0 ? void 0 : setImpressionLogData(others))));
}

export { BlockInspector, BlockInspectorFields };
//# sourceMappingURL=BlockInspector.js.map
